import { CustomReportArgument } from '../../../redux/context/customReports/types'
import { CustomReportVariableExplainer } from '../../../redux/context/customReports/typesVariable'
import backendRequest from '../../../services/api/backendRequest'
import { Company } from '../../../types/company/Company'
import { GET } from '../../../redux/middleware/types'
import { Language } from '../../../types/user/User'
import customReportEndpoints from '../api/customReportEndpoints'

export const fetchVariableExplainer = (
  companyId: Company['id'],
  reportId: number,
  sectionId: number,
  variableId: number,
  date: string,
  lng: Language,
  args?: CustomReportArgument[]
) =>
  backendRequest<CustomReportVariableExplainer>({
    method: GET,
    url: customReportEndpoints.explainer(companyId, reportId, sectionId),
    params: {
      sectionId,
      variableId,
      date,
      lng,
      args: JSON.stringify(args)
    }
  })
